/**
 * This custom hook provides the functionality to save a course with the given parameters.
 */

import {useContext, useState} from "react";
import {useHistory} from "react-router-dom";
import {useSnackbar} from "notistack";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";
import {useIntl} from "react-intl";

const useEditCourse = () => {
    const [saveInProgress, setSaveInProgress] = useState(false)

    const {signedInUser} = useContext(FirebaseAuthContext);
    const history = useHistory();

    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();

    const save = async (courseData) => {
        setSaveInProgress(true)

        const idToken = await signedInUser.getIdToken()
        return fetch('/reg-main/courses/' + courseData.key, {
            method: 'PUT',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                idToken: idToken,
                courseData: {
                    key: courseData.key,
                    name: courseData.name,
                    fromDate: courseData.fromDate,
                    toDate: courseData.toDate,
                    association: courseData.association,
                    disciplines: courseData.disciplines,
                    participants: courseData.participants.map((user) => user.uid),
                    playlists: courseData.playlists.map((playlist) => playlist.key),
                    open: courseData.open
                }
            })
        }).then(async (data) => {
            // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
            if (data.status !== 200) {
                throw new Error((await data.json()).status)
            }

            enqueueSnackbar(
                intl.formatMessage({
                    id: 'app.courses.messages.edit.success',
                    defaultMessage: 'Course {name} saved.'
                }, {name: courseData.name}), {
                    variant: 'success',
                    preventDuplicate: true,
                    autoHideDuration: 3000
                });
            history.push("/admin/courses");
        }).catch((error) => {
            enqueueSnackbar(
                intl.formatMessage({
                    id: 'app.courses.messages.edit.error',
                    defaultMessage: 'Something went wrong while saving the course: {error}'
                }, {error: error.message}), {
                    variant: 'error',
                    preventDuplicate: true,
                    autoHideDuration: 5000
                });
        }).finally(() => {
            setSaveInProgress(false)
        })
    }

    const cancel = () => {
        history.push("/admin/courses");
    }

    return {save, saveInProgress, cancel}
}
export default useEditCourse;